import React, { useEffect, useState, useMemo } from "react";
import { Button } from "../../components/ui/button";
import {
  CirclePlus,
  DeleteIcon,
  Edit,
  FileSpreadsheet,
  ImageIcon,
} from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Separator } from "../../components/ui/separator";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/ui/pagination";
import axios from "axios";
import { toast, Toaster } from "sonner";
import cities from "indian-cities-json";
import { Select as AntdSelect } from "antd";
import { Upload } from "antd";
import * as XLSX from "xlsx";

const token = localStorage.getItem("adminToken");
const Spinner = () => (
  <div className="inline-block w-5 h-5 border-4 border-t-transparent border-gray-600 rounded-full animate-spin"></div>
);

const SubServices = () => {
  const [subServices, setSubServices] = useState([]);
  console.log("subServices : ", subServices)
  const [services, setServices] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // For loading state during add
  console.log("categories : " , categories)
  const [formData, setFormData] = useState({
    service: "",
    subService: "",
    description: "",
    includes: "",
    excludes: "",
    images: [],
    price: "",
    discount: "",
    gst: "",
    commission: "",
  });

  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [updateSubService, setUpdateSubService] = useState(null);
  const [updateSubServiceId, setUpdateSubServiceId] = useState(null);
  const [updateServiceId, setUpdateServiceId] = useState(null);
  const [newUpdateServiceId, setNewUpdateServiceId] = useState(null);
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [deleteSubServiceId, setDeleteSubServiceId] = useState(null);

  const [updateFormData, setUpdateFormData] = useState({
    subService: "",
    description: "",
    includes: "",
    excludes: "",
    images: [],
    price: "",
    discount: "",
    gst: "",
    commission: "",
  });

  const [selectedCities, setSelectedCities] = useState([]);

  const [selectedFiles, setSelectedFiles] = useState([]);

  // Filter subServices based on search term
  const filteredSubServices = useMemo(() => {
    return subServices.filter((service) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        service.name.toLowerCase().includes(searchLower) ||
        service.service?.name?.toLowerCase().includes(searchLower) ||
        service.service?.subCategory?.name
          ?.toLowerCase()
          .includes(searchLower) ||
        service.service?.subCategory?.category?.name
          ?.toLowerCase()
          .includes(searchLower) ||
        service.description?.toLowerCase().includes(searchLower)
      );
    });
  }, [subServices, searchTerm]);

  const handleUpdateChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setUpdateFormData((prevFormData) => ({
        ...prevFormData,
        [name]: [...files],
      }));
    } else {
      setUpdateFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: [...files],
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const cityOptions = cities.cities.map((city) => ({
    value: city.name,
    label: city.name,
  }));

  const handleChangeCities = (values) => {
    setSelectedCities(values);
  };

  const selectedCitiesString = selectedCities.join(",");

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [subServicesRes, servicesRes, subcategoriesRes, catRes] = await Promise.all(
        [
          axios.get("https://wavetechservices.in/api/user/subservices"),
          axios.get("https://wavetechservices.in/api/user/services"),
          axios.get("https://wavetechservices.in/api/user/subcategories"),
          axios.get("https://wavetechservices.in/api/user/categories"),
        ]
      );

      setSubServices(subServicesRes.data.data);
      setServices(servicesRes.data.data);
      setSubCategories(subcategoriesRes.data.data);
      setCategories(catRes.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const data = new FormData();
    data.append("name", formData.subService);
    data.append("description", formData.description);
    data.append("price", formData.price);
    data.append("service", formData.service);
    data.append("includes", formData.includes);
    data.append("excludes", formData.excludes);
    data.append("discount", formData.discount);
    data.append("gst", formData.gst);
    data.append("commission", formData.commission);
    data.append("city", selectedCitiesString);

    formData.images.forEach((image) => {
      data.append("images", image);
    });

    try {
      const response = await axios.post(
        "https://wavetechservices.in/api/admin/sub-service",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("SubService Added successfully");
      setIsSubmitting(false);
      setOpenAdd(false);
      setFormData({
        service: "",
        subService: "",
        description: "",
        includes: "",
        excludes: "",
        images: [],
        price: "",
        discount: "",
        gst: "",
        commission: "",
      });
      setSelectedCities([]);
      fetchData();
    } catch (error) {
      console.error("Error:", error);
      setIsSubmitting(false);
      toast.error(error.response?.data?.message || "Failed to add subservice");
    }
  };
  const x = subServices.filter((sub) => sub.name === "test");
  console.log("test : ", x);
  const handleUpdate = async (service) => {
    // const service = updateSubService
    // console.log("updateSubService : " ,updateSubService)
    // console.log("service : " ,service)
    // console.log("updateServiceId : " ,updateServiceId)
    // console.log("updateSubServiceId : " ,updateSubServiceId)
    // return
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append("name", updateFormData.subService);
    formDataToSend.append("description", updateFormData.description);
    formDataToSend.append("includes", updateFormData.includes);
    formDataToSend.append("excludes", updateFormData.excludes);
    formDataToSend.append("price", updateFormData.price);
    formDataToSend.append("discount", updateFormData.discount);
    formDataToSend.append("gst", updateFormData.gst);
    formDataToSend.append("commission", updateFormData.commission);
    formDataToSend.append("service", newUpdateServiceId);

    updateFormData.images.forEach((image) => {
      formDataToSend.append("images", image);
    });

    try {
      const res = await axios.put(
        // `https://wavetechservices.in/api/admin/service/${service.service._id}/sub-service/${service._id}`,
        // `https://wavetechservices.in/api/admin/service/${updateServiceId}/sub-service/${updateSubServiceId}`,
        `https://wavetechservices.in/api/admin/service/${updateServiceId}/sub-service/${updateSubServiceId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("SubService updated successfully!");
      setIsSubmitting(false);
      setOpenEdit(false);
      fetchData();
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error submitting form:", error);
      toast.error(
        error.response?.data?.message || "Failed to update subservice"
      );
    }
  };

  const handleDelete = async (service) => {
    // console.log("service : " , service)
    // console.log("deleteSubServiceId , deleteServiceId : " , deleteSubServiceId ,deleteServiceId)
    // return
    try {
      setIsSubmitting(true);
      const res = await axios.delete(
        `https://wavetechservices.in/api/admin/service/${deleteServiceId}/sub-service/${deleteSubServiceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("SubService deleted successfully!");
      setIsSubmitting(false);
      fetchData();
      setOpenDelete(false);
    } catch (err) {
      console.error(err, "error");
      toast.error(err.response?.data?.message || "Failed to delete subservice");
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Paginate filtered services
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentServices = filteredSubServices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredSubServices.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const maxVisiblePages = 5;
  const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  const handleEditClick = (service) => {
    setUpdateFormData({
      subService: service.name,
      description: service.description,
      includes: service.includes,
      excludes: service.excludes,
      images: [],
      price: service.price,
      discount: service.discount,
      gst: service.gst,
      commission: service.commission,
    });
    setUpdateSubServiceId(service._id);
    setUpdateServiceId(service.service._id);
    setOpenEdit(true);
  };

  const handleDeleteClick = (service) => {
    setDeleteSubServiceId(service._id);
    setDeleteServiceId(service.service._id);
  };

  function generateRandomSixDigitNumber() {
    return Math.floor(100000 + Math.random() * 900000);
  }

  const handleImageUpload = async () => {
    const formData = new FormData();

    selectedFiles.forEach((file) => {
      formData.append("subserviceImages", file);
    });

    try {
      const response = await axios.post(
        "https://wavetechservices.in/api/admin/sub-service/mutiimages",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Res : ", response);
      if (response.status === 201) {
        toast.success("Images uploaded successfully");
        fetchData();
        setSelectedFiles([]); // reset selected files
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload images");
    }
  };

  // const handleExcelUpload = async (file) => {
  //   try {
  //     const reader = new FileReader();

  //     reader.onload = async (event) => {
  //       const binaryStr = event.target.result;
  //       const workbook = XLSX.read(binaryStr, { type: "binary" });
  //       const sheetName = workbook.SheetNames[0];
  //       const sheet = workbook.Sheets[sheetName];
  //       const data = XLSX.utils.sheet_to_json(sheet);

  //       console.log("Parsed Excel Data:", data);

  //       if (data.length === 0) {
  //         toast.error("Excel file is empty");
  //         return;
  //       }

  //       // Send to backend
  //       const response = await axios.post("https://wavetechservices.in/api/admin/sub-service/bulk", data, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if (response.status === 201) {
  //         toast.success("Bulk Sub-Services uploaded successfully");
  //       }
  //     };

  //     reader.readAsBinaryString(file);
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Failed to upload Excel file");
  //   }
  // };

  const handleExcelUpload = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const formattedData = jsonData.map((item) => ({
        name: item.name,
        description: item.description,
        price: Number(item.price),
        discount: Number(item.discount),
        gst: Number(item.gst),
        commission: Number(item.commission),
        service: item.service,
        city: item.city ? item.city.split(",").map((c) => c.trim()) : [],
        includes: item.includes
          ? item.includes.split(",").map((i) => i.trim())
          : [],
        excludes: item.excludes
          ? item.excludes.split(",").map((e) => e.trim())
          : [],
        icon: [item.image1, item.image2, item.image3, item.image4].filter(
          Boolean
        ),
      }));

      console.log("Formatted Data:", formattedData);
      // return
      // Send to backend
      const response = await axios.post(
        "https://wavetechservices.in/api/admin/sub-service/bulk",
        formattedData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // your admin token
          },
        }
      );

      if (response.status === 201) {
        toast.success("Bulk upload successful!");
      } else {
        toast.error("Something went wrong during upload");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload Excel");
    }
  };

  const handleExcelUpdate = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const updates = jsonData.map((item) => ({
        subServiceId: item.subServiceId,
        name: item.name,
        description: item.description,
        price: Number(item.price),
        discount: Number(item.discount),
        gst: Number(item.gst),
        commission: Number(item.commission),
        city: item.city ? item.city.split(",").map((c) => c.trim()) : [],
        includes: item.includes
          ? item.includes.split(",").map((i) => i.trim())
          : [],
        excludes: item.excludes
          ? item.excludes.split(",").map((e) => e.trim())
          : [],
        icon: [item.image1, item.image2, item.image3, item.image4].filter(
          Boolean
        ),
      }));

      console.log("Formatted Data:", updates); 
      // Send to backend
      // return
      const response = await axios.put(
        "https://wavetechservices.in/api/admin/sub-service/bulk",
        updates,
        {
          headers: {
            Authorization: `Bearer ${token}`,  
          },
        }
      );

      if (response.status === 200) {
        toast.success("Bulk updated successful!");
        console.log("response if : " , response)
      } else {
        toast.error("Something went wrong during upload");
        console.log("response else : " , response)
      }
    } catch (error) { 
      console.error(error);
      toast.error("Failed to upload Excel");
    }
  };

  console.log("currentServices : " , currentServices)

  return (
    <div className="px-[1vw] my-5">
      <Toaster />
      <div className="flex lg:justify-between lg:items-center flex-col lg:flex-row ">
        <h1 className="text-2xl">Sub Services</h1>
        <div className="flex lg:gap-4 items-center gap-2 my-3 lg:my-0">
          <Input
            placeholder="Search by name, service, or category"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // Reset to first page when searching
            }}
          />

          <Dialog open={openAdd} onOpenChange={setOpenAdd}>
            <DialogTrigger>
              <div className="flex items-center">
                <Button className="bg-black px-5 text-white h-9 hover:opacity-90">
                  Add <CirclePlus className="size-2" />
                </Button>
              </div>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
              <DialogHeader className="space-y-6">
                <DialogTitle className="lg:text-2xl text-xl">
                  Add Sub Service
                </DialogTitle>
              </DialogHeader>

              <div className="flex items-center gap-4">
                <Label htmlFor="service" className="w-44">
                  Service
                </Label>
                <Select
                  onValueChange={(value) =>
                    setFormData({ ...formData, service: value })
                  }
                >
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select Services" />
                  </SelectTrigger>
                  <SelectContent>
                    {services.map((service) => (
                      <SelectItem key={service._id} value={service._id}>
                        {service.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="flex items-center gap-4">
                <Label htmlFor="subService" className="w-44">
                  Sub Service
                </Label>
                <Input
                  id="subService"
                  name="subService"
                  type="text"
                  value={formData.subService}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>
              <div className="flex items-center gap-4">
                <Label htmlFor="subService" className="w-44">
                  Cities
                </Label>
                <div className="h-full w-full">
                  <AntdSelect
                    mode="multiple"
                    allowClear
                    className="h-full w-full"
                    placeholder="Select cities"
                    onChange={handleChangeCities}
                    options={cityOptions}
                  />
                </div>
              </div>

              <div className="flex items-center gap-4">
                <Label htmlFor="description" className="w-44">
                  Description
                </Label>
                <Input
                  id="description"
                  name="description"
                  type="text"
                  value={formData.description}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>

              <div className="flex items-center gap-4">
                <Label htmlFor="includes" className="w-44">
                  Includes
                </Label>
                <Input
                  id="includes"
                  name="includes"
                  type="text"
                  value={formData.includes}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>

              <div className="flex items-center gap-4">
                <Label htmlFor="excludes" className="w-44">
                  Excludes
                </Label>
                <Input
                  id="excludes"
                  name="excludes"
                  type="text"
                  value={formData.excludes}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>
              <div className="flex items-center gap-4">
                <Label htmlFor="images" className="w-44">
                  Images
                </Label>
                <Input
                  id="images"
                  name="images"
                  type="file"
                  multiple
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>
              <div className="flex items-center gap-4">
                <Label htmlFor="price" className="w-44">
                  MRP
                </Label>
                <Input
                  id="price"
                  name="price"
                  type="text"
                  value={formData.price}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>
              <div className="flex items-center gap-4">
                <Label htmlFor="discount" className="w-44">
                  Discount
                </Label>
                <Input
                  id="discount"
                  name="discount"
                  type="text"
                  value={formData.discount}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>
              <div className="flex items-center gap-4">
                <Label htmlFor="gst" className="w-44">
                  GST
                </Label>
                <Input
                  id="gst"
                  name="gst"
                  type="text"
                  value={formData.gst}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>
              <div className="flex items-center gap-4">
                <Label htmlFor="commission" className="w-44">
                  Commission
                </Label>
                <Input
                  id="commission"
                  name="commission"
                  type="text"
                  value={formData.commission}
                  onChange={handleChange}
                  className="col-span-3"
                />
              </div>

              <div className="flex justify-center items-center">
                <Button
                  type="submit"
                  className="bg-black px-5 text-white h-9 hover:opacity-90 flex items-center justify-center gap-2"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <Spinner />
                      Adding...
                    </>
                  ) : (
                    <>
                      Add <CirclePlus className="size-2" />
                    </>
                  )}
                </Button>
              </div>
            </DialogContent>
          </Dialog>
          {/* <Upload
            accept=".xlsx,.xls"
            showUploadList={false}
            beforeUpload={(file) => {
              handleExcelUpload(file);
              return false;
            }}
          >
            <Button icon={<FileSpreadsheet size={16} />}>Import Excel</Button>
          </Upload> */}

          <Upload
            accept=".xlsx,.xls"
            showUploadList={false}
            beforeUpload={(file) => {
              handleExcelUpload(file);
              return false; // ✅ prevent automatic upload
            }}
          >
            <Button icon={<FileSpreadsheet size={16} />}>Import Excel</Button>
          </Upload>

          {/* <Upload
            accept=".xlsx,.xls"
            showUploadList={false}
            beforeUpload={(file) => {
              handleExcelUpdate(file);
              return false;  
            }}
          >
            <Button icon={<FileSpreadsheet size={16} />}>Import Excel Update</Button>
          </Upload> */}

          {/* <Upload
              accept="image/*"
              multiple
              showUploadList={true}
              customRequest={({ file, onSuccess }) => { 
                onSuccess("ok");
              }}
              onChange={(info) => {
                const files = info.fileList.map(f => f.originFileObj).filter(Boolean);
                handleImageUpload(files);  
              }}
            >
              <Button icon={<ImageIcon size={16} />}>Upload Images</Button>
            </Upload> */}
          <Upload
            accept="image/*"
            multiple
            showUploadList={true}
            customRequest={({ file, onSuccess }) => {
              onSuccess("ok"); // dummy because we're using our own upload
            }}
            onChange={(info) => {
              const files = info.fileList
                .map((f) => f.originFileObj)
                .filter(Boolean);
              setSelectedFiles(files); // ✅ Only set files, no upload yet
            }}
          >
            <Button icon={<ImageIcon size={16} />}>Select Images</Button>
          </Upload>

          <Button
            type="primary"
            disabled={selectedFiles.length === 0}
            onClick={handleImageUpload}
            style={{ marginTop: 10 }}
          >
            Upload Selected Images
          </Button>
        </div>
      </div>
      <Separator className="my-4" />

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto lg:max-w-[1200px] max-w-[380px] md:max-w-[580px] lg:h-[65vh] h-[58vh] md:h-[70vh]">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Sl No.</TableHead>
                  <TableHead>Categories</TableHead>
                  <TableHead>Sub Categories</TableHead>
                  <TableHead>Service</TableHead>
                  <TableHead>Sub Service</TableHead>
                  <TableHead>Sub Service Id</TableHead>
                  <TableHead>Description</TableHead>
                  <TableHead>Includes</TableHead>
                  <TableHead>Excludes</TableHead>
                  <TableHead>Images</TableHead>
                  <TableHead>Price</TableHead>
                  <TableHead>Discount</TableHead>
                  <TableHead>Commision</TableHead>
                  <TableHead>Action</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {currentServices.length > 0 ? (
                  currentServices.map((service, ind) => (
                    <TableRow key={service._id}>
                      <TableCell>{indexOfFirstItem + ind + 1}.</TableCell>
                      <TableCell>
                        {service?.service?.subCategory?.category?.name}
                      </TableCell>
                      <TableCell>
                        {service?.service?.subCategory?.name}
                      </TableCell>
                      <TableCell>{service?.service?.name}</TableCell>
                      <TableCell>{service?.name}</TableCell>
                      <TableCell>{service._id}</TableCell>
                      <TableCell className="w-[500px]">
                        <Dialog>
                          <DialogTrigger>View Description</DialogTrigger>
                          <DialogContent>
                            <DialogHeader>
                              <DialogTitle>Description</DialogTitle>
                              <DialogDescription>
                                {service?.description}
                              </DialogDescription>
                            </DialogHeader>
                          </DialogContent>
                        </Dialog>
                      </TableCell>
                      <TableCell className="w-[400px]">
                        {service?.includes}
                      </TableCell>
                      <TableCell className="w-[400px]">
                        {service?.excludes}
                      </TableCell>
                      <TableCell className="w-[400px]">
                        <Dialog>
                          <DialogTrigger>View Images</DialogTrigger>
                          <DialogContent>
                            <DialogHeader>
                              <DialogTitle>Added Image</DialogTitle>
                              <DialogDescription>
                                <div className="flex flex-wrap gap-3 my-3">
                                  {service?.icon?.map((img, index) => (
                                    <img
                                      src={`${img}`}
                                      alt=""
                                      key={index}
                                      className="w-32 rounded-md"
                                    />
                                  ))}
                                </div>
                              </DialogDescription>
                            </DialogHeader>
                          </DialogContent>
                        </Dialog>
                      </TableCell>
                      <TableCell className="w-[400px]">
                        Rs {service.price}/-
                      </TableCell>
                      <TableCell className="w-[400px]">
                        {service.discount}%
                      </TableCell>
                      <TableCell className="w-[400px]">
                        {service.commission}%
                      </TableCell>
                      <TableCell>
                        <div className="flex gap-4 items-center">
                          <Dialog open={openEdit} onOpenChange={setOpenEdit}>
                            <DialogTrigger>
                              <Edit
                                className="text-blue-500 size-5 cursor-pointer"
                                onClick={() => handleEditClick(service)}
                              />
                            </DialogTrigger>
                            <DialogContent className="sm:max-w-[425px]">
                              <DialogHeader className="space-y-6">
                                <DialogTitle className="lg:text-2xl text-xl">
                                  Edit SubService
                                </DialogTitle>
                              </DialogHeader>
                              <div className="flex items-center gap-4">
                                <Label htmlFor="service" className="w-44">
                                  Service
                                </Label>
                                <Select
                                  onValueChange={(value) =>
                                    setNewUpdateServiceId(value)
                                  }
                                >
                                  <SelectTrigger className="w-full">
                                    <SelectValue placeholder="Select Services" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {services.map((service) => (
                                      <SelectItem
                                        key={service._id}
                                        value={service._id}
                                      >
                                        {service.name}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              </div>
                              <div className="flex items-center gap-4">
                                <Label htmlFor="subService" className="w-44">
                                  SubService
                                </Label>
                                <Input
                                  id="subService"
                                  type="text"
                                  name="subService"
                                  value={updateFormData.subService}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>

                              <div className="flex items-center gap-4">
                                <Label htmlFor="description" className="w-44">
                                  Description
                                </Label>
                                <Input
                                  id="description"
                                  type="text"
                                  name="description"
                                  value={updateFormData.description}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>

                              <div className="flex items-center gap-4">
                                <Label htmlFor="includes" className="w-44">
                                  Includes
                                </Label>
                                <Input
                                  id="includes"
                                  type="text"
                                  name="includes"
                                  value={updateFormData.includes}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>

                              <div className="flex items-center gap-4">
                                <Label htmlFor="excludes" className="w-44">
                                  Excludes
                                </Label>
                                <Input
                                  id="excludes"
                                  type="text"
                                  name="excludes"
                                  value={updateFormData.excludes}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>

                              <div className="flex items-center gap-4">
                                <Label htmlFor="images" className="w-44">
                                  Images
                                </Label>
                                <Input
                                  id="images"
                                  type="file"
                                  name="images"
                                  multiple
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>

                              <div className="flex items-center gap-4">
                                <Label htmlFor="price" className="w-44">
                                  Price
                                </Label>
                                <Input
                                  id="price"
                                  type="text"
                                  name="price"
                                  value={updateFormData.price}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>
                              <div className="flex items-center gap-4">
                                <Label htmlFor="discount" className="w-44">
                                  Discount
                                </Label>
                                <Input
                                  id="discount"
                                  name="discount"
                                  type="text"
                                  value={updateFormData.discount}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>
                              <div className="flex items-center gap-4">
                                <Label htmlFor="gst" className="w-44">
                                  GST
                                </Label>
                                <Input
                                  id="gst"
                                  name="gst"
                                  type="text"
                                  value={updateFormData.gst}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>
                              <div className="flex items-center gap-4">
                                <Label htmlFor="commission" className="w-44">
                                  Commission
                                </Label>
                                <Input
                                  id="commission"
                                  name="commission"
                                  type="text"
                                  value={updateFormData.commission}
                                  onChange={handleUpdateChange}
                                  className="col-span-3"
                                />
                              </div>

                              <div className="flex justify-center items-center">
                                <Button
                                  type="submit"
                                  className="bg-black px-5 text-white h-9 hover:opacity-90 flex items-center justify-center gap-2"
                                  onClick={() => handleUpdate(service)}
                                  //   onClick={() =>{
                                  //     setUpdateSubService(service)
                                  //     handleUpdate()
                                  //   }
                                  // }
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? (
                                    <>
                                      <Spinner />
                                      Saving...
                                    </>
                                  ) : (
                                    "Save Changes"
                                  )}
                                </Button>
                              </div>
                            </DialogContent>
                          </Dialog>

                          <Dialog
                            open={openDelete}
                            onOpenChange={setOpenDelete}
                          >
                            <DialogTrigger>
                              <DeleteIcon
                                className="text-red-500 size-6 cursor-pointer"
                                onClick={() => handleDeleteClick(service)}
                              />
                            </DialogTrigger>
                            <DialogContent>
                              <DialogHeader>
                                <DialogTitle>
                                  Are you absolutely sure?
                                </DialogTitle>
                                <DialogDescription>
                                  This action cannot be undone. Are you sure you
                                  want to permanently delete this file from our
                                  servers?
                                </DialogDescription>
                              </DialogHeader>
                              <DialogFooter>
                                <Button
                                  type="submit"
                                  onClick={() => handleDelete(service)}
                                  className="flex items-center justify-center gap-2"
                                >
                                  {isSubmitting ? (
                                    <>
                                      <Spinner />
                                      Deleting...
                                    </>
                                  ) : (
                                    "Confirm"
                                  )}
                                </Button>
                              </DialogFooter>
                            </DialogContent>
                          </Dialog>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={13} className="text-center py-4">
                      {searchTerm
                        ? "No matching subservices found"
                        : "No subservices available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>

          {filteredSubServices.length > 0 && (
            <div>
              <Pagination className="mt-4">
                <PaginationContent>
                  {currentPage > 1 && (
                    <PaginationItem>
                      <PaginationPrevious
                        onClick={() => handlePageChange(currentPage - 1)}
                      />
                    </PaginationItem>
                  )}

                  {startPage > 1 && (
                    <>
                      <PaginationItem>
                        <PaginationLink onClick={() => handlePageChange(1)}>
                          1
                        </PaginationLink>
                      </PaginationItem>
                      {startPage > 2 && (
                        <PaginationItem>
                          <span className="px-2">...</span>
                        </PaginationItem>
                      )}
                    </>
                  )}

                  {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                    <PaginationItem key={startPage + i}>
                      <PaginationLink
                        isActive={startPage + i === currentPage}
                        onClick={() => handlePageChange(startPage + i)}
                      >
                        {startPage + i}
                      </PaginationLink>
                    </PaginationItem>
                  ))}

                  {endPage < totalPages && (
                    <>
                      {endPage < totalPages - 1 && (
                        <PaginationItem>
                          <span className="px-2">...</span>
                        </PaginationItem>
                      )}
                      <PaginationItem>
                        <PaginationLink
                          onClick={() => handlePageChange(totalPages)}
                        >
                          {totalPages}
                        </PaginationLink>
                      </PaginationItem>
                    </>
                  )}

                  {currentPage < totalPages && (
                    <PaginationItem>
                      <PaginationNext
                        onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </PaginationItem>
                  )}
                </PaginationContent>
              </Pagination>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SubServices;
